/**
 * import react
 */
import React from 'react';
import PropTypes from 'prop-types';
import Time from 'react-time';
/**
 * import material-ui
 */
import TabelRow from '@material-ui/core/TableRow';
import TabelCell from '@material-ui/core/TableCell';
import moment from 'moment';

const DeviceTsdbTabelBody = (props) => {
  return (
    <>
    {
      props.values
        .sort((currentValue, nextValue) => {
          const currentDate = moment(currentValue[props.timeIndex]);
          const nextDate = moment(nextValue[props.timeIndex]);
          const isAfter = currentDate.isAfter(nextDate);
          const isBefore = currentDate.isBefore(nextDate);
          return isAfter ? -1: isBefore ? 1 : 0;
        })
        .map((val, idx) => {
          return (
            <TabelRow key={idx}>
              {
                val.map((col, idx) => {
                  if (props.timeIndex === idx) {
                    return (
                      <TabelCell key={idx}>
                        <Time value={col} format="YYYY-MM-DD HH:mm" />
                      </TabelCell>
                    );
                  } else {
                    return (
                      <TabelCell key={idx}>{col}</TabelCell>
                    );
                  }
                })
              }
            </TabelRow>
          );
        })
    }
    </>
  );
};

DeviceTsdbTabelBody.propTypes = {
  values: PropTypes.array.isRequired,
  timeIndex: PropTypes.number.isRequired
};

export default DeviceTsdbTabelBody;
